'use strict';

angular.module('mobile-apps').controller('ConnectAndroidAppstoreModalController', [
	'$scope',
	'EventTracker',
	'ModalData',
	'AppstoreIntegration',
	'Utilities',
	'$modalInstance',
	'$timeout',
	'$q',
	function (
		$scope,
		EventTracker,
		ModalData,
		AppstoreIntegration,
		Utilities,
		$modalInstance,
		$timeout,
		$q
	) {

		$scope.data = {
			isLoading: false,
			appName: '',
			privateKey: '',
			clientEmail: ''
		};


		/**
		 * Returns the extension of the given file
         */
		function getFileExtension(file) {
			if (file.name.indexOf('.') !== -1) {
				var fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
				return fileExtension.toLowerCase();
			}

			return undefined;
		}


		$scope.uploadFile = function() {

			// List of properties that are needed in the file and where
			// they should be saved
			var neededProperties = {
				'private_key': 'privateKey',
				'client_email': 'clientEmail'
			};

			// Reset the properties
			for (var propertyName in neededProperties) {
				$scope.data[neededProperties[propertyName]] = undefined;
			}

			var input = document.createElement('input');
			input.type = 'file';

			input.onchange = function(changeEvent) {

				// Get the file the user selected
				var file = changeEvent.path[0].files[0];

				// Check if file has correct type
				var fileExtension = getFileExtension(file);
				if (fileExtension !== 'json') {
					Utilities.showMessage('Error!', 'Wrong file type! Please select a JSON file!', 'error');
					return;
				}

				// Read the content of the file
				var r = new FileReader();
				r.onload = function(e) {
					var contents = e.target.result;

					// Try to parse it, if not possible there is something
					// wrong with the file
					var parsedContent;
					try {
						parsedContent = JSON.parse(contents);
					} catch(e) {
						Utilities.showMessage('Error!', 'Was not possible to read file.<br />Please make sure that it is not damaged!', 'error');
						return;
					}

					// Get the content of the file we are interested in
					var missingProperties = [];
					for (var propertyName in neededProperties) {

						if (parsedContent.hasOwnProperty(propertyName)) {
							// Property got found
							$scope.data[neededProperties[propertyName]] = parsedContent[propertyName];
						} else {
							// Property is missing
							missingProperties.push(propertyName);
						}
					}

					if (missingProperties.length !== 0) {
						Utilities.showMessage('Error!', 'File incomplete.<br /><br />The following properties are missing: ' + missingProperties.join(', '), 'error');
						return;
					}

					// Makes sure that the digest runs and the view updates
					$timeout(function() {});
				};
				r.readAsText(file);

			};

			input.click();
		};



		/**
		 * Uses the data entered by the user to generate a new access token
		 */
		$scope.connectStore = function () {
			var sendData = {
				mobileAppId: ModalData.mobileApp._id,
				storeType: 'android',
				appName: $scope.data.appName,
				clientEmail: $scope.data.clientEmail,
				privateKey: $scope.data.privateKey
			};

			$scope.data.isLoading = true;

			AppstoreIntegration.connect(sendData).$promise
				.then(
					function(data) {
						$scope.data.isLoading = false;

						Utilities.showMessage('Success', 'Successfully connected to Android Playstore!', 'success');
						$modalInstance.close({success: true});
					}
				)
				.catch(
					function(error) {
						$scope.data.isLoading = false;
						Utilities.showMessageErrorResponse(error);
					}
				);
		};


		/**
		 * Close modal
		 */
		$scope.close = function() {
			$modalInstance.dismiss();
		};

	}
]);

